var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlusIcon8X8 = function SvgPlusIcon8X8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "left-arrow-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58491",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 444",
    d: "M5 1v8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 445",
    d: "M9 5H1"
  }))));
};
export default SvgPlusIcon8X8;